// paladin.core.auth
const {
  name,
  version
} = require('../package.json')
import {
  authStore
} from './state/modules/auth'
import * as AuthHelpers from './state/helpers'

const install = (Vue, options) => {
  let _timestamp = null
  if (process.env.NODE_ENV === 'development') {
    _timestamp = new Date()
    // eslint-disable-next-line no-console
    console.log(
      `%c${name}` + `%c#${version}: ` + '%cInstalling Module...',
      'color: #2ecc71',
      'color: #3498db',
      ''
    )
  }

  if (PaladinCoreAuth.installed) {
    return
  }
  PaladinCoreAuth.installed = true

  const {
    store,
    authZero,
    ms,
    callbackRouting,
    onCompleteCallback
  } = options

  if (!store) {
    throw new Error('Please provide a vuex store.')
  }
  if (!authZero) {
    throw new Error('Please provide Auth0 credentials.')
  }
  if (!ms) {
    throw new Error('Please provide Microsoft credentials.')
  }

  // export module vuex stores
  store.registerModule('auth', authStore(Vue, authZero, ms, callbackRouting))
  Vue.$store = Vue.$store || store

  let _callback = null
  if (onCompleteCallback) {
    _callback = onCompleteCallback
  }

  // initialize global moduleRoutes if it doesn't exist
  Vue.$moduleRoutes = Vue.$moduleRoutes ? Vue.$moduleRoutes : []

  // export module routes
  var _statusRoute =
    process.env.NODE_ENV === 'development' ? [{
        path: 'status',
        name: 'status',
        component: () =>
          import( /* webpackChunkName: "status" */ './router/views/status.vue'),
        meta: {
          authRequired: true,
        },
        props: () => ({
          user: store.state.auth.identity || {},
        }),
      },
      {
        path: 'status-new',
        name: 'status-new',
        component: () =>
          import( /* webpackChunkName: "status" */ './router/views/status.vue'),
        meta: {
          authRequired: true,
        },
        props: () => ({
          user: store.state.auth.identity || {},
        }),
      },
    ] : []

  var routes = [{
      path: 'callback',
      name: 'callback',
      meta: {
        authRequired: false, // won't be logged in before the dispatch!
      },
      component: () =>
        import( /* webpackChunkName: "callback" */ './router/views/callback.vue'),
      props: () => ({
        successRoute: callbackRouting.successRoute || {},
        newUserRoute: callbackRouting.newUserRoute || {},
        errorRoute: callbackRouting.errorRoute || {},
        onCompleteCallback: _callback || null,
      }),
    },
    {
      path: 'callbackms',
      name: 'callbackms',
      meta: {
        authRequired: false, // won't be logged in before it runs the set!
      },
      component: () =>
        import( /* webpackChunkName: "callback" */ './router/views/callbackms.vue'),
      props: () => ({
        successRoute: callbackRouting.successRoute || {},
        errorRoute: callbackRouting.errorRoute || {},
      }),
    },
    ..._statusRoute,
    {
      path: 'logoutCallback',
      name: 'logoutCallback',
      meta: {
        authRequired: true,
        // beforeResolve(/* routeTo, routeFrom, */ next) {
        //   next(callbackRouting.successRoute)
        // },
      },
    },
    {
      path: 'logout',
      name: 'logout',
      meta: {
        authRequired: true,
        beforeResolve( /* routeTo, routeFrom, next */ ) {
          store.dispatch('auth/logOut')
          // const authRequiredOnPreviousRoute = routeFrom.matched.some(
          //   (route) => route.meta.authRequired
          // )
          // // Navigate back to previous page, or dashboard as a fallback
          // next(
          //   authRequiredOnPreviousRoute
          //     ? callbackRouting.successRoute
          //     : { ...routeFrom }
          // )
        },
      },
    },
  ]

  Vue.$moduleRoutes = routes

  if (process.env.NODE_ENV === 'development') {
    let _executionTime = new Date() - _timestamp
    let _msColor = _executionTime < 100 ? '#2ecc71' : '#f1c40f'
    if (_executionTime >= 200) _msColor = '#e74c3c'
    // eslint-disable-next-line no-console
    console.log(
      `%c${name}` +
      `%c#${version}: ` +
      '%cInstalled in ' +
      `%c${_executionTime}ms`,
      'color: #2ecc71',
      'color: #3498db',
      '',
      `color: ${_msColor}`
    )
  }
}

const PaladinCoreAuth = {
  install,
  version,
}

export {
  PaladinCoreAuth,
  AuthHelpers
}

// #Automatic Installation
// For people who use your plugin outside of a module system,
// it is often expected that if your plugin is included after
// the Vue script tag, that it will automatically install itself
// without the need to call Vue.use(). You can implement this by
// appending these lines to the end of my-vue-plugin.js:
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(PaladinCoreAuth)
// }
